import store from '@store';

const hasPage = true;

export default {
    beforeEnterList: (to, from, next) => {
        store.dispatch('landingpage/report/updateAssetsCount', true).then(res => {
            res > 1
                ? next()
                : next({
                      name: 'LandingPageOnboarding',
                      query: to.query,
                      params: to.params
                  });
        });
    },
    beforeEnterOnboarding: (to, from, next) => {
        store.dispatch('landingpage/report/updateAssetsCount', true).then(res => {
            res <= 1
                ? next()
                : next({
                      name: 'LandingPageList',
                      query: to.query,
                      params: to.params
                  });
        });
    }
};
